<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in toBePaidTabs"
          :key="index"
        >
          <el-form class="search-style" v-show="activeName === '待付款供应商列表'">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item>
                  <el-select v-model="params.column" @change="changeColumn(params.column)">
                    <el-option
                      v-for="(item, index) in contractScreenConditionPay"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col
                :span="4"
                v-show="
                  params.column !== 'suName' &&
                    params.column !== 'tradeDate' &&
                    params.column !== 'updateDate' &&
                    params.column !== undefined
                "
              >
                <el-form-item>
                  <el-select v-model="params.expression">
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      v-for="(item, index) in expressionList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="6"
                v-if="
                  (params.column !== 'tradeDate' &&
                    params.column !== 'updateDate') ||
                    params.column === undefined
                "
              >
                <el-form-item>
                  <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="6"
                v-if="
                  params.column === 'tradeDate' ||
                    params.column === 'updateDate'
                "
              >
                <el-form-item>
                  <el-date-picker
                    style="width:100%;"
                    v-model="time"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item>
                  <el-button @click="search" type="primary">搜索</el-button>
                  <el-button @click="resetSearch" type>重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form class="search-style" v-show="activeName === '付款记录'">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item>
                  <el-select v-model="params.column" @change="changeColumnPrice(params.column)">
                    <el-option
                      v-for="(item, index) in contractScreenConditionPrice"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="4"
                v-show="
                  params.column === 'applyTotal' ||
                    params.column === 'actualTotal' ||
                    params.column === 'count'
                "
              >
                <el-form-item>
                  <el-select v-model="params.expression">
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      v-for="(item, index) in expressionList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="6"
                v-show="
                  params.column === 'tradeNumber' ||
                    params.column === 'suName' ||
                    params.column === 'createUser' ||
                    params.column === 'staffCnName' ||
                    params.column === undefined ||
                    params.column === 'applyTotal' ||
                    params.column === 'actualTotal' ||
                    params.column === 'count'
                "
              >
                <el-form-item>
                  <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="params.column === 'flag'">
                <el-form-item>
                  <el-select v-model="params.value">
                    <el-option label="付款审核" value="付款审核"></el-option>
                    <el-option label="付款成功" value="付款成功"></el-option>
                    <el-option label="审核不通过" value="审核不通过"></el-option>
                    <el-option label="退回修改" value="退回修改"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="6"
                v-show="
                  params.column === 'dueTime' ||
                    params.column === 'createDate' ||
                    params.column === 'tradeDate'
                "
              >
                <el-form-item>
                  <el-date-picker
                    style="width:100%;"
                    v-model="time"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item>
                  <el-button @click="search" type="primary">搜索</el-button>
                  <el-button @click="resetSearch" type>重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div
            class="box-table"
            :style="{height: tableHeight+'px'}"
            v-show="activeName === '待付款供应商列表'"
          >
            <el-table
              border
              ref="tableRef"
              :data="list"
              tooltip-effect="dark"
              :max-height="tableHeight"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column prop="code" show-overflow-tooltip width="210px" label="供应商名称">
                <template slot-scope="scope">
                  <span @click="onSuName(scope.row)" class="approval">{{scope.row.suName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="accountsPayable" label="应付账款总额">
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.accountsPayable |priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="accountsDue" label="到期应付账款">
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.accountsDue |priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="履行中合同数"></el-table-column>
              <el-table-column prop="tradeDate" label="最初账款到期时间" width="140px">
                <template slot-scope="scope">
                  <span>{{ scope.row.tradeDate | dateFilter }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="toAuditMoney" label="待审核付款金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.toAuditMoney | priceFilterNum }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createUser" label="最近申请人"></el-table-column>
              <el-table-column prop="updateDate" width="140px" label="更新时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.updateDate | dateFilter }}</span>
                </template>
              </el-table-column>
              <el-table-column prop label="操作" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    :disabled="!scope.row.isState"
                    @click="onApplicationForPayment(scope.row)"
                  >申请付款</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="box-table" :style="{height: tableHeight+'px'}" v-show="activeName === '付款记录'">
            <el-table
              border
              ref="tableRef"
              :data="paymentList"
              :row-class-name="tableRowClassName"
              :max-height="tableHeight"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              v-loading="loadingPaymentTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column width="150px" prop="tradeNumber" label="付款编号">
                <template slot-scope="scope">
                  <span @click="onSee(scope.row)" class="approval">{{ scope.row.tradeNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="tradeType" label="付款类型">
                <template slot-scope="scope">
                  <div>{{ statusType[scope.row.tradeType - 1] }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="suName" show-overflow-tooltip label="供应商名称" width="150px">
                <template slot-scope="scope">
                  <div
                    @click="onSuName(scope.row)"
                    class="approval line-limit-length"
                  >{{ scope.row.suName }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="applyTotal" label="申请付款金额" width="120px">
                <template slot-scope="scope">
                  <span>{{ scope.row.applyTotal|priceFilterNum }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="actualTotal" label="实际付款金额" width="120px">
                <template slot-scope="scope">
                  <span>{{ scope.row.actualTotal | priceFilterNum }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="涉及合同数" width="100px"></el-table-column>
              <el-table-column label="最初账款到期时间" width="140px">
                <template slot-scope="scope">
                  <span>{{ scope.row.dueTime | dateFilter }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="flag" show-overflow-tooltip label="付款状态">
                <template slot-scope="scope">
                  <span>{{ scope.row.flag }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createUser" label="提交人"></el-table-column>
              <el-table-column width="140px" label="提交时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate | dateFilter }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="staffCnName" label="处理人"></el-table-column>
              <el-table-column prop="tradeDate" width="140px" label="处理时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.tradeDate | dateFilter }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="150px">
                <template slot-scope="scope">
                  <el-button @click="onSee(scope.row)" type="text">查看</el-button>
                  <el-button
                    v-show="scope.row.flag === '审核不通过'"
                    type="text"
                    :disabled="!scope.row.isInitiate"
                    @click="onSeeAgain(scope.row)"
                  >重新发起</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <pagination
              :currentPage="currentPage"
              :pageSize="pageSize"
              :total="total"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import { formatDate, resetTableLayout } from '@/util/tool'
import { deepClone } from '@/util'

import {
  querySupplierAccountBase,
  queryPayment
} from '@/api/purchase/purchasePlanList'
import { toBePaidTabs } from './util/data'
export default {
  components: {
    pagination: pagination
  },
  data () {
    return {
      statusType: ['采购付款'],
      status: ['失败', '进行中', '交易失败'],
      activeName: '待付款供应商列表', // tabs选中状态
      toBePaidTabs: toBePaidTabs, // tabs状态
      loadingTable: false, // 列表loading
      list: [{}], // 列表数据
      paymentList: [{}],
      loadingPaymentTable: false, // 付款记录
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      params: {
        column: 'suName'
      },
      paramsList: {},
      time: [],
      contractScreenConditionPay: [
        { label: '供应商名称', value: 'suName' },
        { label: '应付账款总额', value: 'accountsPayable' },
        { label: '到期应付账款', value: 'accountsDue' },
        { label: '履行中合同数', value: 'count' },
        { label: '最初账款到期时间', value: 'tradeDate' },
        { label: '待审核付款金额', value: 'toAuditMoney' },
        { label: '更新时间', value: 'updateDate' }
      ], // 筛选条件
      contractScreenConditionPrice: [
        { label: '付款编号', value: 'tradeNumber' },
        { label: '供应商名称', value: 'suName' },
        { label: '申请付款金额', value: 'applyTotal' },
        { label: '实际付款金额', value: 'actualTotal' },
        { label: '涉及合同数', value: 'count' },
        { label: '最初账款到期时间', value: 'dueTime' },
        { label: '付款状态', value: 'flag' },
        { label: '提交人', value: 'createUser' },
        { label: '提交时间', value: 'createDate' },
        { label: '处理人', value: 'staffCnName' },
        { label: '处理时间', value: 'tradeDate' }
      ], // 筛选条件
      titleQuotation: '选择报价单', // 报价单弹窗名称
      expressionList: expressionList,
      tableHeight: window.innerHeight - 380

    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (row.flag === '退回修改') {
        return 'warning-row'
      }
      return ''
    },
    // 搜索
    search () {
      this.paramsList = deepClone(this.params)
      if (this.time && this.time.length === 2) {
        this.paramsList.value = this.time[0]
        this.paramsList.endValue = this.time[1]
      }
      if (
        this.paramsList.value === undefined ||
        this.paramsList.value === '' ||
        this.paramsList.column === undefined
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.currentPage = 1
        this.pageSize = 30
        this.getList()
      }
    },
    // 跳转供应商
    onSuName (row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    // 重置
    resetSearch () {
      this.time = []
      this.params = {
        column: 'suName'
      }
      this.paramsList = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    changeColumnPrice (column) {
      this.time = []
      this.params = {
        column: column,
        expression: 'eq'
      }
    },
    // column change
    changeColumn (column) {
      this.time = []
      this.params = {
        column: column,
        expression: 'eq'
      }
    },

    // tabs切换时触发的事件
    handleClick () {
      this.currentPage = 1
      this.pageSize = 30
      this.time = []
      this.params = {
        column: 'suName'
      }
      this.paramsList = {}

      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList () {
      if (this.activeName === '待付款供应商列表') {
        this.loadingTable = true
        this.list = []
        const params = {
          criteriaVoList: [this.paramsList],
          queryPageName: ''
        }
        querySupplierAccountBase(this.currentPage, this.pageSize, params)
          .then((res) => {
            if (res.data.code === 200) {
              this.loadingTable = false
              this.list = res.data.obj.records
              this.total = res.data.obj.total
              resetTableLayout.call(this, this.$refs.tableRef)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.loadingTable = true
        this.paymentList = []
        const params = {
          criteriaVoList: [this.paramsList],
          queryPageName: ''
        }
        queryPayment(this.currentPage, this.pageSize, params)
          .then((res) => {
            if (res.data.code === 200) {
              this.loadingTable = false
              this.paymentList = res.data.obj.records
              this.total = res.data.obj.total
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    // 申请付款
    onApplicationForPayment (row) {
      this.$router.push({
        name: 'payApplication',
        query: { sabId: row.sabId }
      })
    },
    // 查看
    onSee (row) {
      this.$router.push({
        name: 'paymentDetails',
        query: { scpId: row.scpId }
      })
    },
    // 重新发起
    onSeeAgain (row) {
      this.$router.push({
        name: 'payApplication',
        query: { scpId: row.scpId, sabId: row.sabId, type: 'again' }
      })
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
.number-yet,
.number-wait,
.number-yetCreate {
  bottom: 14px;
  left: 166px;
}
.number-wait {
  left: 253px;
}
.number-yetCreate {
  left: 342px;
}
</style>
